const restrictionTypes = {
    NONE: 'NONE',
    PM_DELIVERY: 'PM_DELIVERY',
    DELIVERY_ONLY: 'DELIVERY_ONLY',
    COLLECTION_ONLY: 'COLLECTION_ONLY',
};

class ShelfProductTileController {
    constructor(config, settings, trolleyService) {
        this.config = config;
        this.settings = settings;
        this.trolleyService = trolleyService;
        this.restrictionTypes = restrictionTypes;
    }

    $onInit() {
        this.productRestriction = this.getRestriction();
        this.shouldShowSavingsTag = this.product.IsOnSpecial && this.product.HasHeaderTag && this.product.HeaderTag.Promotion !== 'Special' && this.product.SavingsAmount > 0;

        if (this.productRestriction === 'PM_DELIVERY') {
            this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionPmDelivery;
        }

        if (this.productRestriction === 'DELIVERY_ONLY') {
            this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionDeliveryOnly;
        }

        if (this.productRestriction === 'COLLECTION_ONLY') {
            this.restrictionDelivery = this.settings.productRestrictions.productTileRestrictionPickUpOnly;
        }
    }

    getRestriction() {
        if (this.product.IsPmDelivery) {
            return this.restrictionTypes.PM_DELIVERY;
        } else if (this.product.IsForCollection && !this.product.IsForDelivery) {
            return this.restrictionTypes.COLLECTION_ONLY;
        } else if (!this.product.IsForCollection && this.product.IsForDelivery) {
            return this.restrictionTypes.DELIVERY_ONLY;
        }
        return this.restrictionTypes.NONE;
    }
}

const shelfProductTileComponentDefinition = {
    bindings: {
        product: '<',
    },
    controller: ['config', 'Settings', 'TrolleyService', ShelfProductTileController],
    template: require('./shelf-product-tile.component.html').trim(),
};

module.exports = {
    ShelfProductTileController,
    shelfProductTileComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-product-tile.component.js